module.exports = __webpack_public_path__ + "static/media/img_30-39.bb1bc787.png";